import {
  ApplicationButton,
  ApplicationStateRegion,
  ApplicationSurface,
} from "../../../components/application";
import AssignmentActivityInspectionModal from "./AssignmentActivityInspectionModal";

function provenanceLabel(activity) {
  return activity.provenance === "my_activity" ? "My activity" : "Provided by All-Voiced";
}

function familyLabel(activity) {
  return activity.family === "cape_vr" ? "CAPE-Vr" : "Perceptual activity";
}

function ActivityOption({ activity, onChoose, onView }) {
  return <article className="av-assignment-activity-option">
    <div>
      <h4>{activity.name}</h4>
      <p className="av-assignment-activity-option__meta">{provenanceLabel(activity)}{activity.version ? ` · Version ${activity.version}` : ""} · {familyLabel(activity)}</p>
      {activity.description ? <p>{activity.description}</p> : null}
    </div>
    <div className="av-app-form-actions">
      <ApplicationButton onClick={() => onChoose(activity)}>Choose</ApplicationButton>
      <ApplicationButton variant="quiet" onClick={() => onView(activity)}>View activity</ApplicationButton>
    </div>
  </article>;
}

export default function AssignmentActivityChooser({
  activities,
  selectedActivity,
  inspection,
  inspectionLoading,
  inspectionError,
  inspectionOpen,
  assignmentId,
  onChoose,
  onChange,
  onView,
  onCloseInspection,
  canCreateActivity = false,
  onCreateActivity,
  changing = false,
  onCancelChange,
}) {
  if (selectedActivity && !changing) {
    return <><div className="av-assignment-activity-selected">
      <p className="av-assignment-activity-option__meta">Selected activity</p>
      <div>
        <h3>{selectedActivity.name}</h3>
        <p>{provenanceLabel(selectedActivity)}{selectedActivity.version ? ` · Version ${selectedActivity.version}` : ""}</p>
      </div>
      <div className="av-app-form-actions">
        <ApplicationButton variant="quiet" onClick={() => onView(selectedActivity)}>View activity</ApplicationButton>
        <ApplicationButton variant="secondary" onClick={onChange}>Change</ApplicationButton>
      </div>
    </div><AssignmentActivityInspectionModal assignmentId={assignmentId} isOpen={inspectionOpen} inspection={inspection} loading={inspectionLoading} error={inspectionError} onClose={onCloseInspection} /></>;
  }

  const system = activities.filter(activity => activity.provenance === "provided_by_allvoiced");
  const personal = activities.filter(activity => activity.provenance === "my_activity");
  return <div className="av-assignment-activity-chooser">
    <p>Choose an activity to assign.</p>
    {activities.length === 0 ? <ApplicationStateRegion status="empty" message="No activities are currently available to assign." /> : null}
    {system.length ? <ApplicationSurface variant="subtle"><h3>Ready-made activities</h3>{system.map(activity => <ActivityOption key={activity.id} activity={activity} onChoose={onChoose} onView={onView} />)}</ApplicationSurface> : null}
    {personal.length ? <ApplicationSurface variant="subtle"><h3>My ready activities</h3>{personal.map(activity => <ActivityOption key={activity.id} activity={activity} onChoose={onChoose} onView={onView} />)}</ApplicationSurface> : null}
    <div className="av-app-form-actions">
      {canCreateActivity && onCreateActivity ? <ApplicationButton variant="secondary" onClick={onCreateActivity}>Create activity</ApplicationButton> : null}
      {changing && selectedActivity && onCancelChange ? <ApplicationButton variant="quiet" onClick={onCancelChange}>Cancel change</ApplicationButton> : null}
    </div>
    <AssignmentActivityInspectionModal assignmentId={assignmentId} isOpen={inspectionOpen} inspection={inspection} loading={inspectionLoading} error={inspectionError} onClose={onCloseInspection} />
  </div>;
}

export { ActivityOption, familyLabel, provenanceLabel };
